import styled from 'styled-components';

export const TimingWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-left: 0.8em;
  ${props => props.theme.mediaQueries.tablet_big_down}{
    margin-left: 0;
  };
`;

export const TimingLabel = styled.div`
  color: ${props => props.theme.colors[props.color]};
  font-family: ${props => props.theme.fontSets[props.font]};
  font-size: 15px;
  ${props => props.theme.mediaQueries.phone}{
    font-size: 12px;
  };
`;



// WEBPACK FOOTER //
// ./src/components/TimeResults/TennisTimig/styles.js